import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 5px;
  background-color: #fff;
`;

export const Content = styled.div`
  flex: 1;
`;

export const SectionTitle = styled.h2`
  font-weight: normal;
`;

export const SectionWrapper = styled.div`
  padding: 15px;
`;
